import { Icon } from 'components/Icons';
import { type ChangeEvent, forwardRef, type LegacyRef } from 'react';
import * as S from './InputStyles';
import type { InputProps } from './types';

const InputWithRef = (
  {
    id = '',
    type = 'text',
    placeholder = '',
    assistiveText,
    label,
    className = '',
    required = false,
    size = { default: 'large' },
    variant = 'default',
    onChange,
    ...rest
  }: InputProps,
  ref: LegacyRef<HTMLInputElement>,
) => {
  if (label || assistiveText || variant === 'underlined') {
    return (
      <S.InputWrapper
        className={className}
        $variant={variant}
      >
        {label && (
          <S.Label htmlFor={id}>
            {label} {required && <span>*</span>}
          </S.Label>
        )}
        {variant === 'underlined' && (
          <S.IconWrapper>
            <Icon icon='Search' />
          </S.IconWrapper>
        )}
        <S.Input
          ref={ref}
          $size={size}
          $variant={variant}
          required={required}
          id={id}
          placeholder={placeholder}
          type={type}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
          {...rest}
        />
        {assistiveText && <S.Text className={`assistive-text ${className}`}>{assistiveText}</S.Text>}
      </S.InputWrapper>
    );
  }

  return (
    <S.Input
      ref={ref}
      $size={size}
      $variant={variant}
      id={id}
      placeholder={placeholder}
      type={type}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      className={className}
      {...rest}
    />
  );
};

const Input = forwardRef(InputWithRef);
export default Input;
